import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {ResourceDetailsPage} from '../ResourceDetailsPage/ResourceDetailsPage'
import {Category} from '../articles/Category/Category'
import {isResourceDetailsPayload} from '../../lib/types/generic-payload'
import {isCategoryPayload} from '../../lib/types/payload'

/**
 * Temporary component to handle template-based routing for the /resources/articles/:topicOrResource route.
 * This route was previously /resources/articles/:topic and always rendered Category component.
 * Now it can serve two types of content based on payload validation order:
 * - CategoryPayload (legacy articles) → Category
 * - ResourceDetailsPayload (new articles) → ResourceDetailsPage
 *
 * TODO: Remove this component once all content has been migrated appropriately.
 */
export function TemporaryTopicOrResource() {
  const routePayload = useRoutePayload<unknown>()

  // Check CategoryPayload first because it requires specific fields (pageHeading, page)
  // that ResourceDetailsPayload doesn't have, preventing false positives
  if (isCategoryPayload(routePayload)) {
    return <Category />
  }

  if (isResourceDetailsPayload(routePayload)) {
    return <ResourceDetailsPage />
  }

  return <Category />
}

try{ TemporaryTopicOrResource.displayName ||= 'TemporaryTopicOrResource' } catch {}